import { BaseMessage } from "./BaseMessage"

export enum ChatThreadKind {
  JOB = "JOB",
  STORE_CUSTOMER = "STORE_CUSTOMER",
}

/**
 * A conversation with a customer: either a job's chat, or the store
 * customer's own chat for messages that aren't about a job.
 */
export type ChatThread =
  | { kind: ChatThreadKind.JOB; jobId: string }
  | { kind: ChatThreadKind.STORE_CUSTOMER; storeCustomerId: string }

export const jobThread = (jobId: string): ChatThread => ({
  kind: ChatThreadKind.JOB,
  jobId,
})

export const storeCustomerThread = (storeCustomerId: string): ChatThread => ({
  kind: ChatThreadKind.STORE_CUSTOMER,
  storeCustomerId,
})

/**
 * The thread a stored message belongs to. The database guarantees exactly
 * one of jobId / storeCustomerId is set.
 */
export const getMessageThread = (message: {
  jobId: BaseMessage["jobId"]
  // Status updates come from job events and have no store customer.
  storeCustomerId?: BaseMessage["storeCustomerId"]
}): ChatThread => {
  if (message.jobId !== null) return jobThread(message.jobId)
  if (message.storeCustomerId) {
    return storeCustomerThread(message.storeCustomerId)
  }
  throw new Error("Message belongs to neither a job nor a store customer")
}

/** Stable string key, e.g. for React keys and selection sets. */
export const chatThreadKey = (thread: ChatThread): string =>
  thread.kind === ChatThreadKind.JOB
    ? `job:${thread.jobId}`
    : `store-customer:${thread.storeCustomerId}`
